<template lang="pug">
.measure
  .measurepop(v-show="showApp")
    .item(v-for='(item,index) in meaureList' :key='index' @click='measureFunc(item,index)')
      van-image(width='25' height='25' :src='item.icon')
      span {{item.name}}
  van-notice-bar(:text='steptipsText'
    v-if='showtips' scrollable
    background='rgba(0, 182, 50, 0.11)'
    color='#57D46E' :left-icon="warnImage")
  .closeArea(v-if='showCloseArea' @click='closeAreaLine') 确定
  .measureDetail(v-show="meaureDetailBoolean")
    .data(v-if='!pointBoolean')
      span {{measureName}}
      span {{measureValue}}
    .point(v-else)
      div
        span X轴坐标
        span {{measureXpoint}}
      div
        span Y轴坐标
        span {{measureYpoint}}
    .right(@click='closeDetail')
      van-image(width='30' height='30' :src='deleteImage')
</template>

<script>
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  data () {
    return {
      meaureList: [
        { name: "长度", icon: require("@/CommonDP/mongeView/appView/images/distance.png"), label: "distance", query: Monge.MeasureType2D.DISTANCE },
        { name: "角度", icon: require("@/CommonDP/mongeView/appView/images/angle.png"), label: "angle", query: Monge.MeasureType2D.ANGLE },
        { name: "面积", icon: require("@/CommonDP/mongeView/appView/images/area.png"), label: "area", query: Monge.MeasureType2D.AREA },
        { name: "坐标", icon: require("@/CommonDP/mongeView/appView/images/point.png"), label: "point", query: Monge.MeasureType2D.POINT },
        { name: "清除", icon: require("@/CommonDP/mongeView/appView/images/clear.png"), query: "clear" }
      ],
      deleteImage: require("@/CommonDP/mongeView/appView/images/clear.png"),
      warnImage: require("@/CommonDP/mongeView/appView/images/warning.png"),
      steptipsText: '',
      showtips: false, // 提示
      measureName: '',
      measureValue: '',
      pointBoolean: false,
      measureXpoint: '',
      measureYpoint: '',
      meaureDetailBoolean: false,
      showCloseArea: false
    };
  },
  computed: {
    showApp() {
      return mongeApp.showApp;
    }
  },
  methods: {
    measureFunc(item) {
      if (item.query == "clear") {
        mongeApiMlib.clearMapMeasure();
        return;
      }
      mongeMutations.changeShowApp(false);
      this.measureName = item.name;
      this.pointBoolean = false;
      switch (item.label) {
        case "distance":
          this.measureValue = "0mm";
          this.meaureDetailBoolean = true;
          // 提示开启
          this.showtips = true;
          this.steptipsText = "请长按屏幕选择坐标点位";
          mongeApiMlib.measureH52D(item.query, {
            callback: (type, data) => {
              if (type === Monge.CallbackType.OUTPUT) {
                this.measureValue = data.result + "mm";
              } else if (type === Monge.CallbackType.DONE) {
                this.showtips = false;
              } else if (type === Monge.CallbackType.SELECT_POINT) {
                this.steptipsText = "选择下一个点位";
              }
            }
          });
          break;
        case "angle":
          this.measureValue = "0°";
          this.meaureDetailBoolean = true;
          // 提示开启
          this.showtips = true;
          this.steptipsText = "请长按屏幕选择坐标点位";
          mongeApiMlib.measureH52D(item.query, {
            callback: (type, data) => {
              if (type === Monge.CallbackType.OUTPUT) {
                this.measureValue = data.result + "°";
              } else if (type === Monge.CallbackType.DONE) {
                this.showtips = false;
              } else if (type === Monge.CallbackType.SELECT_POINT) {
                if (data.count >= 3) {
                  this.steptipsText = "请长按屏幕选择坐标点位";
                } else {
                  this.steptipsText = "选择下一个点位";
                }
              }
            }
          });
          break;
        case "area":
          this.measureValue = "0mm²";
          this.meaureDetailBoolean = true;
          // 提示信息
          this.showtips = true;
          this.steptipsText = "请长按屏幕选择坐标点位";
          mongeApiMlib.measureH52D(item.query, {
            callback: (type, data) => {
              if (type === Monge.CallbackType.OUTPUT) {
                this.measureValue = Math.round(data.result * 1000) / 1000 + "mm²";
              } else if (type === Monge.CallbackType.DONE) {
                this.showtips = false;
                this.showCloseArea = false;
              } else if (type === Monge.CallbackType.SELECT_POINT) {
                if (data.count >= 3) {
                  this.showCloseArea = true;
                  this.steptipsText = "选择下一个点位或者点击确定按钮";
                } else {
                  this.measureValue = "0mm²";
                  this.steptipsText = "选择下一个点位";
                }
              }
            }
          });
          break;
        case "point":
          this.measureXpoint = "";
          this.measureYpoint = "";
          this.pointBoolean = true;
          this.meaureDetailBoolean = true;
          // 提示信息
          this.showtips = true;
          this.steptipsText = "请长按屏幕选择坐标点位";
          mongeApiMlib.measureH52D(item.query, {
            callback: (type, data) => {
              if (type === Monge.CallbackType.OUTPUT) {
                console.log(data);
                this.measureXpoint = Math.round(data.result.x);
                this.measureYpoint = Math.round(data.result.y);
              } else if (type === Monge.CallbackType.DONE) {
                console.log(data);
                this.showtips = false;
                // this.pointBoolean = false
              } else if (type === Monge.CallbackType.SELECT_POINT) {
                console.log(data);
              }
            }
          });
          break;
        default:
          break;
      }
    },
    // 面积确定
    closeAreaLine() {
      mongeApiMlib.measureH5closeArea();
      // this.closeDetail()
    },
    closeDetail() {
      mongeMutations.changeShowApp(true);
      this.showtips = false;
      this.meaureDetailBoolean = false;
    }
  }

};
</script>

<style lang="scss" scoped>
.measurepop{
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  width: calc(100% - 24px);
  height: 60px;
  background: rgba(0, 0, 0, 0.68);
  bottom: 58px;
  z-index: 4;
  margin-left: 12px;
  border-radius: 5px;
  overflow-y: hidden;
  overflow-x: auto;
  .item{
    width: 60px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    span{
      color: #dddddd;
      // line-height: 20px;
    }
  }
}
.van-notice-bar{
  margin-top: 60px;
  width: calc(100% - 140px);
  float: right;
}
.closeArea {
  width: 50px;
  height: 30px;
  position: absolute;
  right: 12px;
  bottom: 60px;
  z-index: 4;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
  line-height: 30px;
}
.measureDetail{
  background: #1A2430;
  position: absolute;
  width: 100%;
  height: 48px;
  bottom: 0px;
  z-index:4;
  display: flex;
  flex-direction: row;
  align-items: center;
  .data{
    width: calc(100% - 50px);
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    color: #fff;
  }
  .point{
    width: calc(100% - 50px);
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    div{
      width: 100%;
      height: 50%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;
      color: #fff;
    }
  }
  .right{
    box-sizing: border-box;
    width: 50px;
    height: 100%;
    border-left: 1px solid #464646;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}
</style>
